import * as React from 'react';
import { type LucideProps, icons } from 'lucide-react';

export interface IconProps extends LucideProps {
  name: keyof typeof icons;
}

export const Icon = ({ name, ...props }: IconProps) => {
  const IconComponent = icons[name];
  if (!IconComponent) {
    console.warn(`Icon ${name} not found`);
    return null;
  }
  return <IconComponent {...props} />;
};

export { icons };
